import { render, staticRenderFns } from "./MeetingSpeakerFix.vue?vue&type=template&id=54e79031&scoped=true"
import script from "./MeetingSpeakerFix.vue?vue&type=script&lang=js"
export * from "./MeetingSpeakerFix.vue?vue&type=script&lang=js"
import style0 from "./MeetingSpeakerFix.vue?vue&type=style&index=0&id=54e79031&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e79031",
  null
  
)

export default component.exports